import React, { useState, useEffect } from 'react';
import { useLaunchDarklySync } from '../hooks';
import { toast } from 'sonner';

interface LaunchDarklySyncWrapperProps {
  children: React.ReactNode;
}

export function LaunchDarklySyncWrapper({ children }: LaunchDarklySyncWrapperProps) {
  const [hasError, setHasError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const maxRetries = 3;

  const { hasError: hookError } = useLaunchDarklySync();

  useEffect(() => {
    if (hookError && !hasError) {
      setHasError(true);
      setRetryCount((prev) => prev + 1);
    } else if (!hookError && hasError) {
      setHasError(false);
      toast.success('Feature flags loaded successfully');
    }
  }, [hookError, hasError]);

  if (hasError && retryCount >= maxRetries) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="text-center max-w-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Feature Flags Unavailable</h2>
          <p className="text-gray-600 mb-4">
            Some features may not work properly. Please refresh the page or contact support if the issue persists.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
